import {
  Text,
  type TextProps,
  Tooltip,
  type TooltipProps,
} from "@mantine/core";
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";

import { truncateString } from "@/utils/helpers";

export interface TruncatedTextProps {
  maxLength?: number;
  textElProps?: Partial<TextProps>;
  tooltipProps?: Partial<TooltipProps>;
  value: string;
}

export const TruncatedText = ({
  maxLength = 50,
  textElProps = {},
  tooltipProps = {},
  value,
}: TruncatedTextProps) => {
  const shouldTruncate = useMemo(
    () => value.length > maxLength,
    [maxLength, value],
  );
  const textEl = useMemo(() => {
    // -3 to accommodate ellipsis
    const displayValue = shouldTruncate
      ? truncateString(value, maxLength - 3)
      : value;
    const { className: propsClassName = "", ...otherProps } = textElProps;
    const className = twMerge([shouldTruncate && "truncate", propsClassName]);

    return (
      <Text className={className} {...otherProps}>
        {displayValue}
      </Text>
    );
  }, [maxLength, shouldTruncate, textElProps, value]);

  if (shouldTruncate) {
    return (
      <Tooltip
        label={value}
        withArrow
        arrowSize={8}
        c="black"
        color="white"
        className="border border-gray-200 z-[1000]"
        {...tooltipProps}
      >
        {textEl}
      </Tooltip>
    );
  }

  return textEl;
};
